module.exports = __webpack_public_path__ + "static/media/logo-web.2a44d9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/black-friday/logo-web.png
// module id = 1451
// module chunks = 0